import { render, staticRenderFns } from "./WalletPage.vue?vue&type=template&id=e01b0ee2&scoped=true"
import script from "./WalletPage.vue?vue&type=script&lang=js"
export * from "./WalletPage.vue?vue&type=script&lang=js"
import style0 from "./WalletPage.vue?vue&type=style&index=0&id=e01b0ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01b0ee2",
  null
  
)

export default component.exports